"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _IconBase = _interopRequireDefault(require("cccisd-icons/dist/IconBase.js"));
var _cccisdTooltip = _interopRequireDefault(require("cccisd-tooltip"));
var _cancelCircle = _interopRequireDefault(require("cccisd-icons/cancel-circle"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var _default = exports["default"] = function _default(props) {
  var field = props.field,
    icons = props.icons;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    showPicker = _useState2[0],
    setShowPicker = _useState2[1];
  var handleShowPicker = function handleShowPicker() {
    setShowPicker(true);
  };
  var onChangeIcon = function onChangeIcon(icon) {
    field.onChange(icon);
    setShowPicker(false);
  };
  var getSelectedIcon = function getSelectedIcon() {
    var selectedIcon = icons.find(function (icon) {
      return icon.id === field.value;
    });
    return selectedIcon || icons[0];
  };
  var handleClosePicker = function handleClosePicker() {
    setShowPicker(false);
  };
  var selectedIcon = getSelectedIcon();
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].picker
  }, /*#__PURE__*/_react["default"].createElement("label", {
    htmlFor: "tabDisplay"
  }, props.label), /*#__PURE__*/_react["default"].createElement("div", {
    id: "tabDisplay",
    className: _style["default"].pickerButton,
    onClick: handleShowPicker
  }, /*#__PURE__*/_react["default"].createElement(_IconBase["default"], {
    viewBox: selectedIcon.viewBox,
    key: selectedIcon.id
  }, /*#__PURE__*/_react["default"].createElement("g", null, selectedIcon.paths.map(function (p, index) {
    return /*#__PURE__*/_react["default"].createElement("path", {
      key: index,
      d: p
    });
  })))), showPicker && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].cover,
    onClick: handleClosePicker
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].iconPicker,
    style: props.style
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].arrow
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].arrow2
  }), icons.map(function (icon) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: icon.id
    }, icon.id === 'none' || icon.id === '' ? /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
      title: "No Icon",
      key: icon.id
    }, /*#__PURE__*/_react["default"].createElement("button", {
      type: "button",
      className: 'btn btn-default ' + (field.value === icon.id ? 'active' : ''),
      onClick: function onClick() {
        onChangeIcon(icon.id);
      }
    }, /*#__PURE__*/_react["default"].createElement(_cancelCircle["default"], null))) : /*#__PURE__*/_react["default"].createElement("button", {
      key: icon.id,
      type: "button",
      className: 'btn btn-default ' + (field.value === icon.id ? 'active' : ''),
      onClick: function onClick() {
        onChangeIcon(icon.id);
      }
    }, /*#__PURE__*/_react["default"].createElement(_IconBase["default"], {
      viewBox: icon.viewBox,
      key: icon.id
    }, /*#__PURE__*/_react["default"].createElement("g", null, icon.paths.map(function (p, index) {
      return /*#__PURE__*/_react["default"].createElement("path", {
        key: index,
        d: p
      });
    })))));
  }))));
};